import React from "react";

function Icon(data) {
  return (

    <svg width={data.w} height={data.h} viewBox="0 0 40 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="DKT-Components/Seite-Bauprojekt-Detail/Share" transform="translate(-245.000000, -102.000000)" fill="#000000" fillRule="nonzero">
                <g id="link_FILL0_wght400_GRAD0_opsz48" transform="translate(245.000000, 102.000000)">
                    <path d="M18.5,20 L10,20 C7.16666667,20 4.79166667,19.0416667 2.875,17.125 C0.958333333,15.2083333 0,12.8333333 0,10 C0,7.16666667 0.958333333,4.79166667 2.875,2.875 C4.79166667,0.958333333 7.16666667,0 10,0 L18.5,0 L18.5,3 L10,3 C8,3 6.33333333,3.66666667 5,5 C3.66666667,6.33333333 3,8 3,10 C3,12 3.66666667,13.6666667 5,15 C6.33333333,16.3333333 8,17 10,17 L18.5,17 L18.5,20 Z M12.25,11.5 L12.25,8.5 L27.75,8.5 L27.75,11.5 L12.25,11.5 Z M21.5,20 L21.5,17 L30,17 C32,17 33.6666667,16.3333333 35,15 C36.3333333,13.6666667 37,12 37,10 C37,8 36.3333333,6.33333333 35,5 C33.6666667,3.66666667 32,3 30,3 L21.5,3 L21.5,0 L30,0 C32.8333333,0 35.2083333,0.958333333 37.125,2.875 C39.0416667,4.79166667 40,7.16666667 40,10 C40,12.8333333 39.0416667,15.2083333 37.125,17.125 C35.2083333,19.0416667 32.8333333,20 30,20 L21.5,20 Z" id="Shape"></path>
                </g>
            </g>
        </g>
    </svg>
  );
}

export default Icon;
